var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBath = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#58595B"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30.9 33.903c-.1 0-.9-.101-1.4-.4-.5-.401-.8-1-.8-1.1M11.3 32.302s-.5.8-1 1.1c-.5.4-1.3.4-1.4.4M33.8 24.403s-1.7 7.899-3.9 7.899h-20c-2.2 0-3.9-7.9-3.9-7.9"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.7 24.403c.5 0 .7-.301.7-.601s-.2-.6-.7-.6H6.2c-.5 0-.7.3-.7.6s.2.6.7.6M30.9 8.402l-2.6.5 2.2 2.2zM29.7 12.402l-.6 1.3M28.1 15.602l-.5 1.3M27 18.602l-.6 1.3M27.2 10.002l-1.2.8M24.1 11.602l-1.2.8M20.9 13.702l-1.2.7M25.1 13.202l-1.1.9M22.6 15.402l-1.1.9M28.3 11.402l-1 1.3M26.5 14.402l-.9 1.2M24.5 17.102l-.9 1.2M33.3 23.102v-16.2l-2.4 1.5"
}))));
export default SvgBath;